import ArrSVG from '@public/icons/btn-arr.svg';
import { MutableRefObject, useEffect, useRef, useState } from 'react';
import { Navigation } from 'swiper';
import { Swiper, SwiperRef, SwiperSlide } from 'swiper/react';
import { Partner } from '@/entities/partner';
import { useMediaQueryDeviceStateValue } from '@/shared/atoms/media-query-device';
import Pagination from '@/shared/components/shared/Pagination';
import { useMounted } from '@/shared/hooks/use-mounted';
import { useOverflowing } from '@/shared/hooks/use-overflowing';
import Image from '../Image';

interface Props {
    partners: Partner[];
    onSelectPartner: (partner: Partner) => void;
}

const OrganizeCategoryItem = ({ partners, onSelectPartner }: Props) => {
    const handleClick = (item: Partner) => {
        onSelectPartner(item);
    };

    const sliderRef = useRef<SwiperRef>();
    const device = useMediaQueryDeviceStateValue();
    const isMobile = device.includes('mobile');

    const [currentRealIndex, setCurrentRealIndex] = useState(0);
    const [lastRealIndex, setLastRealIndex] = useState(0);
    const numSlides = partners.length;

    const slider = useRef<HTMLDivElement | null>(null);
    const isInitialized = useOverflowing(slider);
    const isMounted = useMounted();
    const [loop, setLoop] = useState(false);

    useEffect(() => {
        setLoop(true);
    }, []);

    useEffect(() => {
        sliderRef.current?.swiper.update();
    }, [loop]);

    return (
        <div className="organize-content-category-list-container">
            {partners.length > 1 && isMobile && isMounted ? (
                <div className="organize-content-category-list">
                    <Swiper
                        ref={sliderRef as MutableRefObject<SwiperRef>}
                        modules={[Navigation]}
                        speed={650}
                        slidesPerView={1}
                        spaceBetween={8}
                        loop={loop}
                        onSlideChange={(swiper) => {
                            const newRealIndex = swiper.realIndex;
                            setLastRealIndex(currentRealIndex);
                            setCurrentRealIndex(newRealIndex);
                        }}
                    >
                        {partners.map(
                            (item, index) =>
                                item.logo && (
                                    <SwiperSlide key={index}>
                                        <button
                                            className="organize-content-category-item"
                                            onClick={() => handleClick(item)}
                                            aria-label="Перейти к организации"
                                        >
                                            <Image
                                                className="organize-logo"
                                                width={item.logo.width}
                                                height={item.logo.height}
                                                src={item.logo.src}
                                                alt={item.logo.alt || ''}
                                                title={item.logo.title}
                                                sizes="(max-width: 767px) 100vw, (max-width: 1199px) 50vw, 33vw"
                                            />
                                            <div className="organize-item-btn">
                                                <ArrSVG />
                                            </div>
                                        </button>
                                    </SwiperSlide>
                                ),
                        )}
                    </Swiper>

                    <Pagination
                        numSlides={numSlides}
                        currentRealIndex={currentRealIndex}
                        lastRealIndex={lastRealIndex}
                        prevElClass="slider-prev-btn"
                        nextElClass="slider-next-btn"
                        wrapperClass="organize-pagination-wrapper pagination-wrapper wrapper"
                        hidden={isInitialized}
                        onPrevClick={() => {
                            sliderRef.current?.swiper.slidePrev();
                        }}
                        onNextClick={() => {
                            sliderRef.current?.swiper.slideNext();
                        }}
                    />
                </div>
            ) : (
                <div className="organize-content-category-list swiper__wrapper" ref={slider}>
                    {partners.map(
                        (item, index) =>
                            item.logo && (
                                <button
                                    className="organize-content-category-item"
                                    key={index}
                                    onClick={() => {
                                        handleClick(item);
                                    }}
                                    aria-label="Перейти к организации"
                                >
                                    <Image
                                        className="organize-logo"
                                        width={item.logo.width}
                                        height={item.logo.height}
                                        src={item.logo.src}
                                        alt={item.logo.alt || ''}
                                        title={item.logo.title}
                                        sizes="(max-width: 767px) 100vw, (max-width: 1199px) 50vw, 33vw"
                                    />
                                    <div className="organize-item-btn">
                                        <ArrSVG />
                                    </div>
                                </button>
                            ),
                    )}
                </div>
            )}
        </div>
    );
};

export default OrganizeCategoryItem;
